import React from 'react';
import { useIntl } from 'react-intl';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import { formatDate } from '@/utils/dateHelper';
import { validationStatusIconProps } from '../helper';
import DataManagementDataModelToolsMenu from './DataManagementDataModelToolsMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import ReportsEvents from '../../reports/hooks/events';

const DataManagementDataModelCardItem = ({
  category,
  code,
  upward,
}) => {
  const intl = useIntl();
  const {
    disableValidate,
    isLoading,
    lastValidationDate,
    name,
    valid,
  } = Selectors.useDataManagementDataModelItem(category, code);
  const validate = Events.useValidateDatasetData(category, { code });
  const showReports = ReportsEvents.useShowDataModelReports(category, { code });

  return (
    <CardItem className="aridhia-data-management-data-model-item">
      <NameDescriptionCard
        asLabel
        entity="datamodel"
        icon={validationStatusIconProps(valid).name}
        iconColour={isLoading ? undefined : validationStatusIconProps(valid).colour}
        iconMessage={intl.formatMessage({ id: validationStatusIconProps(valid).message })}
        name={intl.formatMessage({ id: 'dataset.data.datamodel.reports.for' }, { name })}
        loading={isLoading}
        meta={
          lastValidationDate
            ? intl.formatMessage({
              id: 'dataset.data.validation.date',
            }, { date: formatDate(lastValidationDate) })
            : undefined
        }
        title={intl.formatMessage({ id: validationStatusIconProps(valid).message })}
      >
        <div className="float-r">
          <DataManagementDataModelToolsMenu
            disableValidate={disableValidate || isLoading}
            listItem
            name={name}
            showReports={showReports}
            upward={upward}
            validate={validate}
          />
        </div>
      </NameDescriptionCard>
    </CardItem>
  );
};

export default DataManagementDataModelCardItem;
